//Hooks
import { get } from 'svelte/store';
//Helpers
import { devices_status } from 'src/stores/device-runtime/status';
import { devices } from 'src/stores/lists/devices';
import { doesSupportLocalActions } from '../../local/supported/local_action_supported_helpers';
import { findDeviceByChannelMode } from '../../local/core/local_action_components_helpers';
import { buildActionsLabels } from '../../local/ui/local_actions_view_helpers';
//Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const getAvailableWebhookIP = (deviceIP: string): string => {
	const num = '(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)',
		m = deviceIP?.match(
			new RegExp(`^(https?:\\/\\/)?(${num}\\.${num}\\.${num}\\.${num})(:\\d{2,5})?(\\/|$)`),
		);
	if (m?.[2]) return `${m[2]}${m[7] || ''}`;
	return null;
};

export const findDevicesByWebhookIP = (ip: String): Device[] => {
	if (!ip) return [];
	return Object.values(get(devices)).filter(
		(dev: Device) =>
			getDeviceIP(dev) == ip &&
			doesSupportLocalActions(dev) &&
			(dev.channel == 0 || dev.channel >= 2200) &&
			!dev.shared &&
			!/^(bthome-device)$/.test(dev?.type),
	) as Device[];
};

export const findDevicesByChannel = (device: Device, job: ActionJob): Device => {
	return Object.values(get(devices)).find(
		(dev: Device) =>
			dev?.id?.startsWith && dev.id.startsWith(device.id) && findDeviceByChannelMode(dev, job),
	) as Device;
};

export const getDeviceIP = (device: Device) => {
	const status = devices_status.getByRealId(device.id),
		ip = getAvailableWebhookIP(status?.eth?.ip)
			? status.eth.ip
			: status?.wifi_sta
				? status?.wifi_sta?.ip
				: status?.wifi?.sta_ip;
	return getAvailableWebhookIP(ip) || getAvailableWebhookIP(device.ip);
};

export const getDeviceLabels = (action: ActionJob, device: Device) => {
	if (action.error) return [];
	return buildActionsLabels([action], device.id);
};
